(function ($) {
  var videoBlockSplitWidthV1 = {
    setup: function ($elements, context) {
      var $modules = $elements;

      $modules.each(function () {
        var $module = $(this);
        var $play = $('.js-play', $module);
        var provider = $module.data('video-provider');
        var isYoutube = provider === 'youtube';
        var isHTML5 = provider === 'html5';

        $play.once().on('click', function (event) {
          event.preventDefault();

          var opts = {
            context: context,
            provider: provider
          };

          if (!!isYoutube) {
            opts.youTubeId = $module.data('youtube-id');
          } else if (!!isHTML5) {
            opts.content = $module.find('video').wrap('<div />').parent().html();
          }

          site.videos.open(opts);

          return false;
        });
      });
    }
  };

  /**
   * We initialize each type of video separately because we don't know if/when their respective libraries are loaded
   */

  $(document).bind('youtubeIframeAPI.loaded', function () {
    var $elements = $('.js-basic-tout-overlay--v1').filter("[data-video-provider='youtube']");

    if ($elements.length) {
      videoBlockSplitWidthV1.setup($elements, document);
    }
  });

  Drupal.behaviors.tout_basic_overlay_v1 = {
    attach: function (context, settings) {
      var $elements = $('.js-basic-tout-overlay--v1').filter("[data-video-provider='html5']");

      if ($elements.length) {
        videoBlockSplitWidthV1.setup($elements, context);
      }
    }
  };

  Drupal.behaviors.toutOverlayV1 = {
    attach: function (context) {
      var first = true;
      var $module = $('.js-basic-tout-overlay--v1', context);

      $module.each(function () {
        var $module = $(this);
        var $overlay = $('.js-overlay', $module);
        var $content = $('.js-overlay-content', $module);

        $overlay.on('click', function (event) {
          event.preventDefault();
          generic.overlay.launch({
            className: 'tout-overlay',
            transition: 'fade',
            content: $content.html()
          });
        });

        var $reviews = $('.basic-tout__reviews', $module);
        var $write_a_review_link = $('.basic-tout__write-a-review-link', $reviews);
        var $read_reviews_link = $('.basic-tout__read-reviews-link', $reviews);
        var $product_base_id = $reviews.attr('data-prod-base-id');

        if (first && typeof $BV !== 'undefined') {
          $BV.ui('rr', 'show_reviews', {
            productId: $product_base_id
          });
        }

        if (typeof $product_base_id !== 'undefined') {
          $read_reviews_link.on('click', function (event) {
            event.preventDefault();
            if (typeof $BV !== 'undefined') {
              $BV.ui('rr', 'show_reviews', {
                productId: $product_base_id,
                onEvent: function (json) {
                  if (json.eventSource == 'Display' && json.eType == 'Read') {
                    /* if(window.location.hash === '#BVRRContainer') {
                      $("html,body").scrollTop($("#bv_prod_header").offset().top);
                      $("#bv_prod_header").text(prodname);
                    }*/
                  }
                }
              });
            }
          });

          $write_a_review_link.on('click', function (event) {
            event.preventDefault();
            if (typeof $BV !== 'undefined') {
              $BV.ui('rr', 'submit_review', {
                productId: $product_base_id
              });
            }
          });
        }

        first = false;
      });
    }
  };
})(jQuery);
